
import { ActionTypes } from "@/stores/action-types";
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import ToggleSwitch from "../Components/ToggleSwitch.vue";
import gameApplication from "../../game/game-app";

const ACCEPT_EVERYONE = "ACCEPT_EVERYONE";
const ACCEPT_FRIENDS_ONLY = "ACCEPT_FRIENDS_ONLY";

const LARGE_BALL = "LARGE_BALL";
const SMALL_BALL = "SMALL_BALL";

export default defineComponent({
  name: 'SettingsModal',

  data: () => ({
    acceptChallengesFrom: ACCEPT_EVERYONE,
    hitPositionSize: SMALL_BALL,
    acceptEveryone: ACCEPT_EVERYONE,
    acceptFriendsOnly: ACCEPT_FRIENDS_ONLY,
    smallBall: SMALL_BALL,
    largeBall: LARGE_BALL,
  }),

  setup() {
    const isGuest = gameApplication.getPlayer().player.guest;
    return { isGuest };
  },

  computed: {
    /**
     * Create get/set mutator methods to use the Vuex action.
     */
    settings: {
      // This is used to get/set the settings via 2 way binding.
      get() {
        return this.$store.state.settings;
      },
      // This is not being used because 2-way binding is being used to set the settings.
      // If 2 way-binding was not bing used this would be necessaty.
      set(settings) { 
        this.$store.dispatch(ActionTypes.SETTINGS, settings);
      }
    }
  },

  methods: {   
    onClose(): void {
      if (gameApplication.getInGame() === true || gameApplication.getGameKind() == 'PRACTICE') {
        gameApplication.getBillardGame().stick.active = true;
        
        // Restart the practice game.
        // If the player is in the practice room the settings are chagned.
        // This is because if the default game is changed this will cause issues with the practice game. 
        gameApplication.startPractice();
      }

      this.$emit('close');
    },
  },

  components: { Modal, ToggleSwitch },
});
